import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { BookOpen, Brain, Heart, Shield, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const features = [{
    icon: <Brain className="w-6 h-6" data-id="element-89" />,
    text: 'Creencias heredadas sobre el dinero'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-90" />,
    text: 'Culpa cultural y autosabotaje'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-91" />,
    text: 'Identidad femenina y prosperidad'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-92" />,
    text: 'Seguridad interna al ganar y administrar más'
  }, {
    icon: <BookOpen className="w-6 h-6" data-id="element-93" />,
    text: 'Pensamiento de abundancia sin desconexión emocional'
  }];
  return <Section background="white" className="overflow-hidden" data-id="element-94">
      <div className="text-center mb-16" data-id="element-95">
        <span className="text-[#D4AF37] font-semibold tracking-widest uppercase text-sm" data-id="element-96">
          Por eso nació este programa
        </span>
        <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6" data-id="element-97">
          Mente de Rica: <br data-id="element-98" />
          30 días para pensar como Millonaria
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-99">
          No es un ebook más. No es motivación barata. No es “ley de atracción”
          vacía. Es un proceso de reprogramación de identidad financiera,
          diseñado especialmente para mujeres latinas que quieren crecer sin
          perder su esencia.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-101">
          <h3 className="text-3xl font-bold mb-8" data-id="element-102">
            ¿Qué hace diferente a Mente de Rica?
          </h3>
          <p className="text-lg text-gray-600 mb-8" data-id="element-103">
            Durante 30 días trabajas en:
          </p>

          <div className="space-y-6" data-id="element-104">
            {features.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center p-4 bg-[#FDFBF7] rounded-lg border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-colors" data-id="element-105">
                <div className="p-3 bg-white rounded-full shadow-sm text-[#D4AF37] mr-4" data-id="element-106">
                  {feature.icon}
                </div>
                <span className="text-lg font-medium text-gray-800" data-id="element-107">
                  {feature.text}
                </span>
              </motion.div>)}
          </div>

          <div className="mt-10 p-6 bg-black text-white rounded-xl text-center" data-id="element-108">
            <p className="text-xl font-serif" data-id="element-109">
              No te dice: “Haz más”. <br data-id="element-110" />
              <span className="text-[#D4AF37]" data-id="element-111">
                Te enseña: “Piensa distinto”.
              </span>
            </p>
            <p className="mt-2 text-gray-400 text-sm" data-id="element-112">
              Y cuando la mente cambia… las decisiones cambian. Los resultados
              cambian.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="relative" data-id="element-113">
          <div className="bg-[#FDFBF7] p-8 md:p-12 rounded-2xl border border-gray-100 shadow-xl relative overflow-hidden" data-id="element-114">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/10 rounded-bl-full" data-id="element-115"></div>

            <h3 className="text-2xl font-bold mb-6" data-id="element-116">
              Una metáfora que lo explica todo
            </h3>

            <div className="space-y-6 text-gray-700 leading-relaxed" data-id="element-117">
              <p data-id="element-118">Imagina que el dinero es un idioma.</p>
              <p className="font-medium text-lg" data-id="element-119">
                No es que seas “mala con el dinero”. Es que nadie te enseñó a
                hablarlo correctamente.
              </p>
              <p data-id="element-120">
                Mente de Rica es ese entrenamiento diario que por fin te enseña
                el idioma de la prosperidad desde tu cultura, tu historia y tus
                valores.
              </p>
            </div>

            <div className="mt-8 flex justify-center" data-id="element-121">
              
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}